import { LinearProgress } from '@mui/material'
import React, { Suspense } from 'react'

import BookmarkContentAreaComponent from 'components/bookmark/BookmarkContentAreaComponent'
import BookmarkHeaderComponent from 'components/bookmark/BookmarkHeaderComponent'
import BookmarkTabAreaComponent from 'components/bookmark/BookmarkTabAreaComponent'
import { ReactComponent as BookmarkResizeIconHorizontal } from 'resource/bookmark_resize_icon_horizontal.svg'

const HorizontalBookmarkAreaComponent: React.FC = () => {
  return (
    <div className="HorizontalBookmarkFrame">
      <div className="HorizontalBookmarkResizeHandle">
        <BookmarkResizeIconHorizontal />
      </div>
      <Suspense fallback={<LinearProgress className="linear_progress" />}>
        <div className="HorizontalBookmarkArea">
          <BookmarkHeaderComponent />
          <BookmarkTabAreaComponent />
          <BookmarkContentAreaComponent />
        </div>
      </Suspense>
    </div>
  )
}

export default HorizontalBookmarkAreaComponent
